/**
 * @file 加盟員検索モーダルの共済加入履歴ボタン
 */
'use strict'

/**
 * @classname BtnOrganizationMutualAidHistorySearch
 * @classdesc 加盟員検索モーダルの共済加入履歴ボタン
 */
export default class BtnOrganizationMutualAidHistorySearch {
	/**
	 * @constructor
	 * @param {jQuery} $e - $('.btn-organization-mutual-aid-history-search')
	 * @param {instance} controller
	 */
	constructor($e, controller) {
		console.log('BtnOrganizationMutualAidHistorySearch.constructor')
		this._$e = $e
		this._controller = controller
		this._$formControls = $('.organization-mutual-aid-history-search-wrap').find('.form-control')
		this._$e.on('click', () => this.onClick())
	}


	/**
	 * クリックのコールバック
	 *
	 * @memberof BtnOrganizationMutualAidHistorySearch
	 * @return {undefined}
	 */
	onClick() {
		console.log('BtnOrganizationMutualAidHistorySearch.onClick')
		window.open(`${this._$e.data('href')}${this.generateQueryParameter()}`, '_blank')
	}


	/**
	 * クエリパラメータ生成
	 *
	 * @memberof BtnOrganizationMutualAidHistorySearch
	 * @return {undefined}
	 */
	generateQueryParameter() {
		console.log('BtnOrganizationMutualAidHistorySearch.getQueryParameter')
		let queryParameter = ''
		this._$formControls.each((index, element) => {
			queryParameter += `${index == 0 ? '?' : '&'}${$(element).attr('name')}=${$(element).val()}`
		})
		return queryParameter
	}
}
